<template>
  <Languages />
</template>
